import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=2bb1e7a8&scoped=true&"
import script from "./ScrollableTable.vue?vue&type=script&lang=js&"
export * from "./ScrollableTable.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableTable.vue?vue&type=style&index=0&id=2bb1e7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1e7a8",
  null
  
)

export default component.exports